"use client";

import { useEffect, useState } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    console.error("[global-error]", error);
  }, [error]);

  return (
    <html lang="pt-BR">
      <body style={{ fontFamily: "system-ui, sans-serif", padding: 24, maxWidth: 640, margin: "40px auto" }}>
        <h1 style={{ fontSize: 20, marginBottom: 8 }}>Ops, algo quebrou 😕</h1>
        <p style={{ fontSize: 14, color: "#666", marginBottom: 16 }}>
          Um erro inesperado aconteceu. Aperta &ldquo;Tentar de novo&rdquo; que geralmente resolve.
          Se persistir, copia a mensagem abaixo e manda pro suporte.
        </p>

        <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
          <button
            onClick={reset}
            style={{ padding: "8px 16px", background: "#000", color: "#fff", border: 0, borderRadius: 6, cursor: "pointer" }}
          >
            Tentar de novo
          </button>
          <a
            href="/"
            style={{ padding: "8px 16px", background: "#f3f3f3", color: "#000", textDecoration: "none", borderRadius: 6 }}
          >
            Ir pro início
          </a>
          <button
            onClick={() => setShowDetails((s) => !s)}
            style={{ padding: "8px 16px", background: "transparent", color: "#666", border: "1px solid #ddd", borderRadius: 6, cursor: "pointer" }}
          >
            {showDetails ? "Esconder" : "Detalhes"}
          </button>
        </div>

        {showDetails ? (
          <pre
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              borderRadius: 6,
              padding: 12,
              fontSize: 11,
              whiteSpace: "pre-wrap",
              overflowWrap: "anywhere",
              maxHeight: 400,
              overflow: "auto",
            }}
          >
            <strong>Mensagem:</strong> {error.message || "(sem mensagem)"}
            {"\n\n"}
            <strong>Digest:</strong> {error.digest || "(nenhum)"}
            {"\n\n"}
            <strong>Stack:</strong>
            {"\n"}
            {error.stack || "(sem stack)"}
            {"\n\n"}
            <strong>UA:</strong>
            {"\n"}
            {typeof navigator !== "undefined" ? navigator.userAgent : "-"}
          </pre>
        ) : null}
      </body>
    </html>
  );
}
